import { convertImageToBase64 } from '../../utils/imageProcessor';
import { apiPost } from '../apiClient';

/**
 * Uploads a captured recipe photo and returns its public URL.
 *
 * Compresses the image (reusing the same pipeline as the Gemini scan), then POSTs it
 * to `/api/recipes/upload-image`, which stores it in Vercel Blob and returns the URL.
 * Vercel Blob is already provisioned for this project (used by the bug reporter), so
 * this avoids the Firebase Storage setup entirely. Returns `null` on any failure so
 * the caller can still save the recipe without an image rather than blocking the save.
 */
export async function uploadRecipeImage(
  imageUri: string,
  userId: string,
  documentId: string,
): Promise<string | null> {
  try {
    if (!imageUri) return null;
    const { base64, mimeType } = await convertImageToBase64(imageUri);
    const data = await apiPost<{ url?: string }>('/api/recipes/upload-image', {
      base64,
      mimeType,
      documentId,
      userId,
    });
    return data.url ?? null;
  } catch (err) {
    console.warn('[photoImport] Recipe image upload failed; saving without image:', err);
    return null;
  }
}
